var render = function render(){var _vm=this,_c=_vm._self._c;return _c('client-only',[_c('span',{staticClass:"shimmer",style:({ height: _vm.height, width: _vm.computedWidth })},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }